import React, { useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import "./speechRecognition.css"

const Dictaphone = (props) => {
    const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

    const { setQuestion } = props;
    useEffect(() => {
        console.log(transcript)
        if (transcript) {
            setQuestion(transcript);
        }
    }, [transcript, setQuestion]);


    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }


    const startListening = () => {
        console.log(props.langOpt)
        if (props.langOpt === 'Japanese') {
            SpeechRecognition.startListening({ continuous: true, language: 'ja-JP' });
        } else {
            SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
        }
    };
    const stopListening = () => {
        SpeechRecognition.stopListening();
        resetTranscript();
    };

    return (
        <div className="mic-container">
            {!listening &&
                <img className="mic-button" src="./microphoneStart.svg" alt="mic-start" onClick={startListening} ></img>
            }
            {listening && <div className="circle" onClick={stopListening}>
                <img
                    src="./microphoneListning.png" // Replace with your microphone image path
                    alt="Microphone"
                    className="microphone"
                />
            </div>}
        </div>
    );
};
export default Dictaphone;